import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-es';
import { ApiProviderService } from 'src/app/services/api-provider.service';
@Injectable()
export class EncryptionService {

  keySize = 256;
  salt = CryptoJS.default.lib.WordArray.random(16);
  iv = CryptoJS.default.lib.WordArray.random(128 / 8);
  private privateKey = '%DaQGi3E1$3Z';
  // well known algorithm to generate key
  key = CryptoJS.default.PBKDF2(this.privateKey, this.salt, {
    keySize: this.keySize / 32,
    iterations: 100
  });

  constructor(private apiRef: ApiProviderService) {
    this.privateKey += this.apiRef.vDir.split('/').join(''); // acts as replace all because IE doesn't support replaceAll
   }

   // For angular onbly encryption/decryption
   encryptObjRabbit(obj: any): string {
     const value = JSON.stringify(obj);
     const encryptedString = CryptoJS.default.Rabbit.encrypt(value, this.privateKey).toString();
     return encryptedString;
   }

  decryptObjRabbit(value: string): any {
    if (value === '') {
      return '';
    }

    const bytes  = CryptoJS.default.Rabbit.decrypt(value, this.privateKey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.default.enc.Utf8));
    return decryptedData;
  }

  // for encrypting to the .NET API
  encryptObjAes(obj: any): string {
    const value = JSON.stringify(obj);
    return this.encryptAes(value);
  }

  encryptAes(value: string) {
    const encrypted = CryptoJS.default.AES.encrypt(value, this.key, {
      iv: this.iv,
      padding: CryptoJS.default.pad.Pkcs7,
      mode: CryptoJS.default.mode.CBC
    });
    // combine everything together in base64 string
    const result = CryptoJS.default.enc.Base64.stringify(this.salt.concat(this.iv).concat(encrypted.ciphertext));
    return result;
  }

  // decryptAes(value: string): any {
  //   const decode = (str: string):string => Buffer.from(str, 'base64').toString('binary');
  //   let bytes = decode(value) ;
  //   bytes = bytes.substring(16,bytes.length-1); //remove salt
  //   bytes = bytes.substring(16,bytes.length-1); //remove iv

  //   var decrypted = CryptoJS.default.AES.decrypt(bytes, this.key, {
  //     iv: this.iv,
  //     padding: CryptoJS.default.pad.Pkcs7,
  //     mode: CryptoJS.default.mode.CBC
  //   });
  //   var decryptedData = decrypted.toString();
  //   return decryptedData;

  //   // var decryptedData = JSON.parse(bytes.toString(CryptoJS.default.enc.Utf8));
  //   // return decryptedData;
  // }

}
